// extracted by mini-css-extract-plugin
export default {"shopByCategory":"ShopByCategory_shopByCategory__UAQS-","shopByCategory__title":"ShopByCategory_shopByCategory__title__Qhis9"};